var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "C3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF977C;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4100",
    className: "st0",
    d: "M2,0h16c1.1,0,2,0.9,2,2v16c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.1,11.4c-0.1,0.9-0.4,1.6-1,2.2c-0.6,0.6-1.4,0.8-2.4,0.8c-1.1,0-2-0.4-2.6-1.1c-0.6-0.7-0.9-1.7-0.9-3V9.8 c0-0.8,0.1-1.5,0.4-2.2s0.7-1.1,1.2-1.4s1.2-0.6,1.9-0.6c1,0,1.8,0.3,2.4,0.8s0.9,1.3,1,2.2H8.2c0-0.6-0.2-1-0.5-1.2S7.1,7,6.6,7 c-0.6,0-1,0.2-1.3,0.6C5,8,4.9,8.7,4.9,9.6v0.6c0,0.9,0.1,1.6,0.4,2s0.7,0.6,1.3,0.6c0.5,0,0.9-0.1,1.2-0.4s0.4-0.6,0.5-1.2h1.7 V11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.8,9.2h0.9c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.3-0.5,0.3-0.9c0-0.3-0.1-0.6-0.3-0.8s-0.5-0.3-0.8-0.3 S13.2,7,13,7.2c-0.2,0.2-0.3,0.4-0.3,0.7h-1.8c0-0.4,0.1-0.8,0.4-1.2s0.6-0.6,1-0.8s0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2.1,0.6 c0.5,0.4,0.8,1,0.8,1.8c0,0.4-0.1,0.8-0.4,1.1c-0.3,0.3-0.6,0.6-0.9,0.8c0.5,0.2,0.8,0.4,1.1,0.8c0.3,0.4,0.4,0.8,0.4,1.2 c0,0.8-0.3,1.4-0.8,1.8c-0.5,0.4-1.3,0.7-2.2,0.7s-1.5-0.2-2.1-0.7s-0.8-1-0.8-1.8h1.7c0,0.3,0.1,0.6,0.4,0.8 c0.3,0.2,0.5,0.3,0.9,0.3s0.7-0.1,0.9-0.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.9-0.5-1.3-1.4-1.3h-0.9V9.2H12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3);
export default __webpack_public_path__ + "static/media/C3.1cc57a4bb793dea9a8b087b64138dcc5.svg";
export { ForwardRef as ReactComponent };